import { render, staticRenderFns } from "./HealthCeremony.vue?vue&type=template&id=536be41e"
import script from "./HealthCeremony.vue?vue&type=script&lang=js"
export * from "./HealthCeremony.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports